import {ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Output} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractMultiselectInput} from "../abstract-multiselect-input";
import {FUISelectAction} from "../../../select-action";
import {FUIEventsService} from "../../../../events/events.service";import {FUIOptionsService} from "../../../framework/options.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPillMultiselectInputComponent),
            multi: true
        }
    ],
    selector: "fui-pill-multiselect-input",
    styleUrls: ["../multiselect-input.scss"],
    templateUrl: "./pill-multiselect-input.component.html"
})
export class FUIPillMultiselectInputComponent extends FUIAbstractMultiselectInput {
    @Input() allowLabelMarkup: boolean = false;
    @Input() removable: boolean = true;
    @Input() showSelections: boolean = true;

    /**
     * Optional additional action buttons
     */
    @Input() public actions: FUISelectAction[];

    /**
     * Emitted when an action is clicked
     */
    @Output() public action$: EventEmitter<FUISelectAction> = new EventEmitter<FUISelectAction>();

    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(changeDetectorRef, elementRef, eventsService, optionsService);
    }

    /**
     * Invoked when an optional action button is clicked
     */
    public actionClicked(action: FUISelectAction): void {
        if (!action.disabled) {
            this.action$.emit(action);
        }
    }
}
